define('casino/providers/Betsoft',['jquery'], function($) {
    'use strict';

    function Betsoft(casino, gameFunctions) {
        if (!(this instanceof Betsoft)) {
            throw new TypeError('Betsoft constructor cannot be called as a function.');
        }

        this.casino = casino;
        this.gameFunctions = gameFunctions;
    }

    function freeMode(betsoft, game, options) {
        betsoft.gameFunctions.hideHelpButton();
        var provider = betsoft.casino.getProvider(game);
        var src = provider.urlDemo;

        var splitIdAndCode = game.code.split('_');
        if (splitIdAndCode[0] !== 'BET') {
            throw new Error('Illegal game code not starting with BET: ' + game.code);
        }

        var $gameHolder = options.gameHolder;

        var $game = $gameHolder.find('.game');
        $game.empty();

        src += $.param({
            gameid: game.publishCode,
            lang: game.language,
            bankId: provider.bankId,
            wmode: 'transparent'
        });

        betsoft.gameFunctions.switchToFreeMode(game, {
            gameHolder: options.gameHolder,
            type: 'iframe',
            src: src
        });
    }

    function realMode(betsoft, game, options, data) {
        betsoft.gameFunctions.hideHelpButton();
        var provider = betsoft.casino.getProvider(game);
        var src = provider.url;

        var splitIdAndCode = game.code.split('_');
        if (splitIdAndCode[0] !== 'BET') {
            throw new Error('Illegal game code not starting with YGG: ' + game.code);
        }

        var $gameHolder = options.gameHolder;

        var $game = $gameHolder.find('.game');
        $game.empty();

        src += $.param({
            gameid: game.publishCode,
            lang: game.language,
            bankId: provider.bankId,
            mode: 'real',
            wmode: 'transparent',
            token: data.sessionId + '_' + game.publishCode
        });

        betsoft.gameFunctions.switchToRealMode(game, {
            gameHolder: options.gameHolder,
            type: 'iframe',
            src: src
        });
        betsoft.gameFunctions.verifyCurrency(data.currency);
    }

    Betsoft.prototype = {
        constructor: Betsoft,
        freeMode: function(game, options) { freeMode(this, game, options); },
        realMode: function(game, options, data) { realMode(this, game, options, data); }
    };

    return Betsoft;
});
